import axios from 'axios';

export default{
    state: {
        subscribeProducts: []
    },

    getters: {

        getSubscribeProductsAmount: state => {
            return state.subscribeProducts.length
        },

        getSubscribeProuctIndex: state => id => {
            return state.subscribeProducts.findIndex(product => product.id === id)
        },

        getSubscribeProuctById: state => id => {
            return state.subscribeProducts.find(product => product.id === id)
        },
    },

    mutations: {
        ADD_PRODUCT_SUBSCRIBE: (state, product) => {
            state.subscribeProducts.push(product);
        },

        ADD_PRODUCT_SUBSCRIBE_ID: (state, data) => {
            state.subscribeProducts[data.index].subscribe_product_id = data.product.subscribe_product_id;
        },

        REMOVE_PRODUCT_SUBSCRIBE: (state, index) => {
            state.subscribeProducts.splice(index, 1)
        }
    },

    actions: {

        getSubscribeProduct({commit}){
            axios
                .get(axios.defaults.baseURL + 'product_subscribes')
                .then(response => {
                    response.data.products.forEach(product => {
                        commit('ADD_PRODUCT_SUBSCRIBE', product);
                    })
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true;
                });
        },

        addSubscribeProduct({commit, dispatch}, $product){
            axios
                .post(axios.defaults.baseURL + 'product_subscribes',{
                    'product_id': $product.id,
                })
                .then(response => {
                    console.log('Added axios');
                })
                .catch(error => {
                    console.log(error);
                })
        },

        async addSubscribeProductId({commit}, $data){
            return axios
                .get(axios.defaults.baseURL + 'product_subscribes/' + $data.product.alias,{
                    params: {
                        'product_id': $data.product.id
                    }
                })
                .then(response => {
                    if (response.data.message === 'success'){
                        $data.product.subscribe_product_id = response.data.subscribe_product.id;
                        commit('ADD_PRODUCT_SUBSCRIBE_ID', {index: $data.index, product: $data.product});
                        console.log('Added commit');
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },

        removeSubscribeProduct({commit}, $data){
            axios
                .delete(axios.defaults.baseURL + 'product_subscribes/' + $data.stateSubscribeProduct.subscribe_product_id)
                .then(response => {
                    commit('REMOVE_PRODUCT_SUBSCRIBE', $data.index)
                    console.log('Deleted axios and commit');
                })
                .catch(error => {
                    console.log(error);
                })
        },

        async checkSubscribe({commit, getters, state, dispatch}, $product){

            if (!$product.subscribe){
                commit('ADD_PRODUCT_SUBSCRIBE', $product)
                dispatch('addSubscribeProduct', $product)

            }else{
                const index = getters.getSubscribeProuctIndex($product.id)
                const stateSubscribeProduct = getters.getSubscribeProuctById($product.id)

                if (!stateSubscribeProduct.hasOwnProperty('subscribe_product_id')){
                    await dispatch('addSubscribeProductId', {index, 'product': $product});
                }

                dispatch('removeSubscribeProduct', {index, stateSubscribeProduct})
            }
        },

    },
}



// WEBPACK FOOTER //
// ./src/store/subscribeProduct.js